import { z } from 'zod';

export function inferApiResultSchema<T extends z.ZodTypeAny>(schema: T) {
  return z.object({
    data: schema,
  });
}

export function inferPaginatedApiResponse<T extends z.ZodTypeAny>(schema: T) {
  return z
    .object({
      pagination: z.object({
        offset: z.number().nonnegative(),
        limit: z.number().nonnegative().max(100),
        total: z.number().nonnegative().optional(),
      }),
    })
    .merge(inferApiResultSchema(schema));
}
